// extracted by mini-css-extract-plugin
export var center = "_u-2";
export var clickableRow = "_u-5";
export var expandedRow = "_u-7";
export var hoverable = "_u-4";
export var left = "_u-1";
export var right = "_u-3";
export var row = "_u-0";
export var selectedRow = "_u-6";
export var summaryRow = "_u-8";